import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { NbAuthService, NbAuthToken } from '@nebular/auth';
import { switchMap } from 'rxjs/operators';
import { OfferListResponse, OfferListResponse1 } from '../models/offer/offer-list-response';
import { Constants } from '../models/constants.model';
import { Offer } from '../models/offer/offer';
import { BaseClient } from './base-client.service';

@Injectable()
export class OfferClient extends BaseClient {

    public static readonly BASE_ENDPOINT = Constants.API_BASE_URL + '/api/offers';

    public list(): Observable<OfferListResponse> {
        return this.authService.getToken().pipe(switchMap((token) => {
            return this.http.get<OfferListResponse>(OfferClient.BASE_ENDPOINT, {headers: this.getHeaders(token)});
        }));
    }
    
    public list1(id: number): Observable<OfferListResponse1> {
        return this.authService.getToken().pipe(switchMap((token) => {
            return this.http.get<OfferListResponse1>(OfferClient.BASE_ENDPOINT+"/getOffersByStore/"+id, {headers: this.getHeaders(token)});
        }));
    }

    public show(id: string): Observable<Offer> {
        return this.authService.getToken().pipe(switchMap((token) => {
            return this.http.get<Offer>(OfferClient.BASE_ENDPOINT + '/' + id, {headers: this.getHeaders(token)});
        }));
    }

    public store(formData: FormData): Observable<Offer> {
        return this.authService.getToken().pipe(switchMap((token) => {
            return this.http.post<Offer>(OfferClient.BASE_ENDPOINT, formData, {headers: this.getHeaders(token, false)});
        }));
    }

    public update(id, formData: FormData): Observable<Offer> {
        formData.append('_method', 'PUT');
        return this.authService.getToken().pipe(switchMap((token) => {
            return this.http.post<Offer>(OfferClient.BASE_ENDPOINT + '/' + id, formData, {headers: this.getHeaders(token, false)});
        }));
    }

    public delete(id): Observable<any> {
        return this.authService.getToken().pipe(switchMap((token) => {
            return this.http.delete<any>(OfferClient.BASE_ENDPOINT + '/' +  id, {headers: this.getHeaders(token)});
        }));
    }

}
